import { render } from "./BaseLoadingAnimation.vue?vue&type=template&id=53de1093&scoped=true"
import script from "./BaseLoadingAnimation.vue?vue&type=script&lang=ts"
export * from "./BaseLoadingAnimation.vue?vue&type=script&lang=ts"

import "./BaseLoadingAnimation.vue?vue&type=style&index=0&id=53de1093&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53de1093"

export default script